import React, { useState, useEffect, useCallback } from 'react';
import apiAnalyticsService from '../services/apiAnalyticsService';

const ServerMonitor = ({ isMobile }) => {
   
    const [metrics, setMetrics] = useState(null);
   
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            const metricsRes = await apiAnalyticsService.getServerMetrics(isMobile);

            setMetrics(metricsRes.data.data);
      
        } catch (error) {
            console.error("Failed to fetch server data", error);
      
        } finally {
            setLoading(false);
        }
    }, [isMobile]);

    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, 10000); // refresh every 10s
        return () => clearInterval(interval);
    }, [fetchData]);


    const formatBytes = (bytes) => {
        if (!bytes) return '0 MB';
        const mb = bytes / (1024 * 1024);
        if (mb > 1024) {
            return (mb / 1024).toFixed(2) + ' GB';
        }
        return mb.toFixed(2) + ' MB';
    };

    return (
        <div className="server-monitor-container" style={{ marginTop: '30px' }}>  
            <h3 style={{ marginBottom: '20px', color: '#2c3e50', fontSize: '18px', fontWeight: 600 }}>Server Monitor {isMobile && '- Mobile API'}</h3>
            {loading && <div className="analytics-loading">Loading server data...</div>}
            {!metrics && !loading && <div className="analytics-loading">Failed to load server data...</div>}
            {metrics && !loading && (
                <div className="charts-grid half" style={{ marginTop: '20px' }}>
                    <div className="chart-card">
                        {/* <h4>Server OS <span style={{fontSize:'17px'}}>(Local Disk : D)</span></h4> */}
                        <h4>Scalahosting Server<span style={{fontSize:'17px'}}>(S Panal)</span></h4>
                        <ul style={{ listStyle: 'none', padding: 0, marginTop: '15px', color: '#34495e', lineHeight: '2' }}>
                            <li><strong>RAM Usage:</strong> {metrics.server.ramUsagePercent.toFixed(1)}% ({formatBytes(metrics.server.usedRAM)} / {formatBytes(metrics.server.totalRAM)})</li>
                            <li><strong>CPU Load:</strong> {metrics.server.cpuUsagePercent.toFixed(1)}%</li>
                            <li><strong>Disk Usage:</strong> {metrics.server.disk?.usagePercent || 0}% ({formatBytes(metrics.server.disk?.used)} / {formatBytes(metrics.server.disk?.total)})</li>
                        </ul>
                    </div>
                    <div className="chart-card">
                        {/* <h4>Medhorizone Admin Service <span style={{fontSize:'17px'}}>(Node.js Process Metrics)</span></h4> */}
                        <h4>Medhorizone {isMobile ? 'Mobile API' : 'Admin'} - App<span style={{fontSize:'17px'}}>({isMobile ? 'api.medhorizone.com' : 'admin.medhorizone.com'})</span></h4>
                        <ul style={{ listStyle: 'none', padding: 0, marginTop: '15px', color: '#34495e', lineHeight: '2' }}>
                            <li><strong>Process ID (PID):</strong> {metrics.node.pid}</li>
                            <li><strong>RSS Memory:</strong> {formatBytes(metrics.node.rss)}</li>
                            <li><strong>Heap Used:</strong> {formatBytes(metrics.node.heapUsed)} / {formatBytes(metrics.node.heapTotal)} ({metrics.node.heapUsagePercent.toFixed(1)}%)</li>
                        </ul>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ServerMonitor;
